
export function smoothScrollTo (container, element, offset, duration) {
  function easeInOutCubic (t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  }
  const getTop = function (element, start) {
    // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
    if (element.nodeName === 'HTML') return -start
    return element.getBoundingClientRect().top + start
  }

  const defaultValue = {
    duration: 500,
    offset: 0,
    container: window
  }

  const requestAnimationFrame = window.requestAnimationFrame ||
         window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
         function (fn) {
           window.setTimeout(fn, 16)
         }

  duration = duration || defaultValue.duration
  offset = offset || defaultValue.offset
  container = container || defaultValue.container

  if (typeof container === 'string') {
    container = document.querySelector(container)
  }

  const scrollTo = element
  if (!scrollTo) return // Do not scroll to non-existing node

  const startPoint = container.scrollTop || window.pageYOffset
  // Get the top position of an element in the document
  // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
  let end = getTop(scrollTo, startPoint)

  // Ajusts offset from the end
  end += offset

  const clock = Date.now()
  const step = function () {
    // the time elapsed from the beginning of the scroll
    const elapsed = Date.now() - clock
    // calculate the scroll position we should be in
    let position = end
    if (elapsed < duration) {
      position = startPoint + (end - startPoint) * easeInOutCubic(elapsed / duration)

      requestAnimationFrame(step)
    } else {
      // location.replace('#' + scrollTo.id)
      // this will cause the :target to be activated.
    }

    container === window ? container.scrollTo(0, position) : (container.scrollTop = position)
  }
  step()
}
